const POSTAL_CODE_FORMATS = {
  US: {
    regex: /^\d{5}(-\d{4})?$/,
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
    extendedMask: (value) => {
      if (value && value.length > 5) {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return [/\d/, /\d/, /\d/, /\d/, /\d/];
    },
    startsWithLetter: false,
    uppercase: false
  },
  CA: {
    regex: /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/,
    mask: [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/],
    extendedMask: () => [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/],
    startsWithLetter: true,
    uppercase: true
  }
};

export const SUPPORTED_COUNTRIES = Object.keys(POSTAL_CODE_FORMATS);

export const detectCountryFromPostalCode = (postalCode) => {
  if (!postalCode) return null;
  const code = String(postalCode);
  
  for (const [country, format] of Object.entries(POSTAL_CODE_FORMATS)) {
    if (format.regex.test(code)) {
      return country;
    }
  }
  return null;
};

export const isValidPostalCode = (postalCode, country) => {
  if (!postalCode || !country) return false;
  const format = POSTAL_CODE_FORMATS[country];
  if (!format) return false;
  return format.regex.test(String(postalCode));
};

export const validatePostalCode = (postalCode) => {
  return detectCountryFromPostalCode(postalCode) !== null;
};

export const getPostalCodeMask = (value, country) => {
  if (country && POSTAL_CODE_FORMATS[country]) {
    return POSTAL_CODE_FORMATS[country].mask;
  }
  
  const firstChar = value?.charAt(0);
  if (firstChar && /[A-Za-z]/.test(firstChar)) {
    return POSTAL_CODE_FORMATS.CA.mask;
  }
  return POSTAL_CODE_FORMATS.US.mask;
};

export const getExtendedPostalCodeMask = (value, country) => {
  if (country && POSTAL_CODE_FORMATS[country]) {
    return POSTAL_CODE_FORMATS[country].extendedMask(value);
  }
  return POSTAL_CODE_FORMATS.US.extendedMask(value);
};

export const getPostalCodePipe = (country) => {
  if (country && POSTAL_CODE_FORMATS[country]?.uppercase) {
    return (conformedValue) => conformedValue.toUpperCase();
  }
  return undefined;
};

export const formatPostalCode = (value, country) => {
  if (!value) return "";
  if (country === "CA") {
    // Canadian postal code: A1A 1A1
    const cleaned = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 6);
    if (cleaned.length <= 3) return cleaned;
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
  }
  // US postal code: 12345 or 12345-1234
  const digits = value.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};
